/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { pxToEm } from 'utils/styles/style_helpers';



/* ++++++++++ --------------- EXPORT --------------- ++++++++++ */
// ADD USER MODAL
// utliizes utils and CSS-IN-JS (JS objects converted to CSS using a library)
export default theme => ({
    adduser: {
    	extend: theme.modal.form,
        maxWidth: pxToEm(849),
        '& .permissionslabel':{
            marginBottom: pxToEm(15)
        }
    }
});